import { DetailPermissionType, ManageRoleType } from '@/types/manage-role';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ManageRoleState = {
  dataManageRole: ManageRoleType[];
  loading: boolean;
  dataDetailsPermission?: DetailPermissionType;
};

export const manageRoleInitialState: ManageRoleState = {
  dataManageRole: [],
  loading: false,
  dataDetailsPermission: undefined,
};

const slice = createSlice({
  name: 'manageRole',
  initialState: manageRoleInitialState,
  reducers: {
    setManageRoleAction(state, { payload }: PayloadAction<{ dataManageRole: ManageRoleType[] }>) {
      state.dataManageRole = payload.dataManageRole;
    },
    setDetailsPermissionAction(state, { payload }: PayloadAction<DetailPermissionType>) {
      state.dataDetailsPermission = payload;
    },
    addManageRoleAction(state, { payload }: PayloadAction<ManageRoleType>) {
      state.dataManageRole = [payload, ...state.dataManageRole];
    },
    updateManageRoleAction(state, { payload }: PayloadAction<ManageRoleType>) {
      state.dataManageRole = state.dataManageRole.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    },
  },
});

export const {
  setManageRoleAction,
  setDetailsPermissionAction,
  addManageRoleAction,
  updateManageRoleAction,
} = slice.actions;
export default slice.reducer;
